import { Box } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectAddOnForm } from "../../../redux/selector";
import { actions } from "../../../redux/slice";
import { AddOnFormValues } from "../../../types";
import { ADD_ON_FORM_I18N_PREFIX } from "../data";
import { FormSection } from "../VehicleDetails/FormControls";
import { AddOnSectionConfig } from "../types";
import FormOptionCard from "app/components/FormOptionCard";
import { useStyles } from "./styles";

type AddOnSectionsProps = {
  sections: AddOnSectionConfig[];
  hideTopBorderOnFirst?: boolean;
};

const getRowClassName = (columnCount: number, styles: ReturnType<typeof useStyles>) => {
  if (columnCount === 1) {
    return `${styles.cardRow} ${styles.cardRow1}`;
  }

  if (columnCount === 3) {
    return `${styles.cardRow} ${styles.cardRow3}`;
  }

  return `${styles.cardRow} ${styles.cardRow2}`;
};

const AddOnSections = ({ sections, hideTopBorderOnFirst }: AddOnSectionsProps) => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const formValues = useSelector(selectAddOnForm);

  const labels = {
    note: `${ADD_ON_FORM_I18N_PREFIX}.FIELDS.NOTE`,
    quantity: `${ADD_ON_FORM_I18N_PREFIX}.FIELDS.QUANTITY`,
    size: `${ADD_ON_FORM_I18N_PREFIX}.FIELDS.SIZE`,
    location: `${ADD_ON_FORM_I18N_PREFIX}.FIELDS.LOCATION`,
    itemType: `${ADD_ON_FORM_I18N_PREFIX}.FIELDS.ITEM_TYPE`,
  };

  const updateItem = (
    field: keyof AddOnFormValues,
    value: Partial<AddOnFormValues[keyof AddOnFormValues]>
  ) => {
    dispatch(actions.updateAddOnFormField({ field, value }));
  };

  if (!formValues) {
    return null;
  }

  return (
    <>
      {sections.map((section, sectionIndex) => (
        <FormSection
          key={section.titleKey}
          titleKey={section.titleKey}
          titleClassName={styles.sectionTitle}
          hideTopBorder={hideTopBorderOnFirst && sectionIndex === 0}
        >
          <Box className={styles.sectionContent}>
            {section.rows.map((row, rowIndex) => (
              <Box
                key={`${section.titleKey}-${rowIndex}`}
                className={getRowClassName(row.length, styles)}
              >
                {row.map((cardConfig) => (
                  <FormOptionCard
                    key={String(cardConfig.field)}
                    config={cardConfig}
                    value={formValues[cardConfig.field]}
                    labels={labels}
                    onChange={(value) => updateItem(cardConfig.field, value)}
                    onRadioModalTrigger={
                      cardConfig.radioModalTriggerOptions?.length
                        ? () => dispatch(actions.openAddOnTyingStripModal())
                        : undefined
                    }
                  />
                ))}
              </Box>
            ))}
          </Box>
        </FormSection>
      ))}
    </>
  );
};

export default AddOnSections;
